import { createSlice } from '@reduxjs/toolkit';
import customPagesState, { ICustomPagesState } from './custom-page-state';
import customPagesReducers from './custom-page-reducers';


const customPagesSlice = createSlice({
  name: 'customPages',
  initialState: customPagesState,
  reducers: customPagesReducers,
});

export const customPagesActions = customPagesSlice.actions;

type RootWithCustomPages = { customPages: ICustomPagesState };

export const selectCustomPages = (state: RootWithCustomPages) =>
  state?.customPages?.pages;

export const selectCurrentCustomPageId = (state: RootWithCustomPages) =>
  state?.customPages?.currentPageId;

export const selectCurrentCustomPage = (state: RootWithCustomPages) =>
  state?.customPages?.pages.find((page) => page.id === Number(state.customPages.currentPageId)) ??
  state?.customPages?.pages[0];

export const selectNonDefaultCustomPages = (state: RootWithCustomPages) =>
  state?.customPages?.pages.filter((page) => page.id !== 0);

export default customPagesSlice;